import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'cancel',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'ReservationCancel',
				),
			store,
			'RESERVATION_CANCEL',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/User/ReservationRecord/Cancel/index.js